<template src="./vehicleoverview.html"></template>
<script>
  import { mapState } from "vuex";
  import Axios from "axios";
  import UpcomingEvent from "@/pages/upcomingevent/upcomingevent";
  export default {
    components: {
      UpcomingEvent,
    },
    props: {
      RequestFor: String,
      Title: String,
    },
    data() {
      return {
        UpcomingEvent: {},
        DashboardData: {},
        DashboardReport: {},
        DashboardReportData: {},
        CalenderEvent: [],
        OtherData: [],
        VehicleWarningCnt: 0,
        ShowDashboardReportDetailLoader: false,
      };
    },
    mounted() {
      this.GetDashBoardReport();
      //this.GetUpcomingEventList();
    },
    methods: {
      GetDashBoardReport() {
        var Type = "vehicle";
        if (this.RequestFor == "AssetsList") {
          Type = "assets";
        }
        Axios.post(Endpoints.Dashboard.DashboardReport, {
          token: localStorage.getItem("token"),
          type: Type,
          item_type: this.RequestFor,
        }).then((Response) => {
          if (Response.data.success) {
            this.DashboardReport = Response.data.DashboardReport;
          }
        });
      },
      ShowDashboardReportDetail(type) {
        this.ShowDashboardReportDetailLoader = true;
        Axios.post(Endpoints.Dashboard.DashboardReportData, {
          token: localStorage.getItem("token"),
          type: type,
          item_type: this.RequestFor,
        }).then((Response) => {
          this.ShowDashboardReportDetailLoader = false;
          if (Response.data.success) {
            this.DashboardReportData = Response.data.DashboardReportData;
          }
        });
      },
      GetUpcomingEventList() {
        Axios.post(Endpoints.Dashboard.UpcomingEvent, {
          token: localStorage.getItem("token"),
          RequestFor: this.RequestFor,
        }).then((Response) => {
          if (Response.data.success) {
            this.UpcomingEvent = Response.data.upcoming_event;
            this.CalenderEvent = Response.data.calender_event;
            this.OtherData = Response.data.other_data;
            var ActionsNeededCount = 0;
            this.CalenderEvent.forEach((element, index) => {
              if (element.status == "red") {
                ActionsNeededCount++;
              }
              if (element.status == "yellow") {
                ActionsNeededCount++;
              }
            });
            if (document.getElementById("ActionsNeededCount")) {
              document.getElementById("ActionsNeededCount").innerHTML =
                ActionsNeededCount;
              if (this.OtherData.redStatusCnt >= 1) {
                document.getElementsByClassName(
                  "urgent-task-btn"
                )[0].innerHTML =
                  this.OtherData.redStatusCnt + " Urgent Tasks Required";
                document.getElementsByClassName(
                  "urgent-task-btn"
                )[0].style.display = "block";
              } else {
                document.getElementsByClassName(
                  "urgent-task-btn"
                )[0].style.display = "none";
              }
            }
          }
          this.VehicleWarningCnt = 0;
          var VehicleWarningArr = [];
          for (var i = 0; i < this.UpcomingEvent.length; i++) {
            if (
              (this.UpcomingEvent[i]["type"] == "vehicle" ||
                this.UpcomingEvent[i]["type"] == "vehiclecheck") &&
              (this.UpcomingEvent[i]["status"] == "yellow" ||
                this.UpcomingEvent[i]["status"] == "orange")
            ) {
              //this.VehicleWarningCnt = this.VehicleWarningCnt + 1;
              VehicleWarningArr[this.UpcomingEvent[i]["vrm"]] =
                this.UpcomingEvent[i]["vrm"];
            }
          }
          this.VehicleWarningCnt = Object.keys(VehicleWarningArr).length;
        });
      },
    },
  };
</script>
<style scoped>
  .btn.vehicle-task-required {
    position: absolute;
    right: 10px;
    top: 3px;
    font-size: 9px !important;
  }
</style>
